export const multiguru = {
  resources: {
    proxy: 'proxy/',
    become: 'become/',
    'group': 'groups/',
    'group.expanded': 'groups/expand/'
  }
}



// WEBPACK FOOTER //
// ./src/mixins/apis/multiguru.js